<div class="place-content-center">
  <div>
    <div class="flex items-center justify-between gap-x-2">
      <div>Create Package</div>
      <div class="relative flex items-center">
        <i class="pi pi-file-edit" style="font-size: 1.5rem"></i>
      </div>
    </div>
  </div>
</div>
